import React from "react";

interface ISummaryProps {
  summary?: React.ReactNodeArray;
}

const summaryStyle = {
  // paddingTop: "1rem"
  color: "#000",
};

export const Summary: React.FC<ISummaryProps> = (props: ISummaryProps) => {
  return (
    <div>
      {props.summary?.map(
        (summaryNode, index) =>
          summaryNode && (
            <div style={summaryStyle} key={"price_text_" + index}>
              {summaryNode}
            </div>
          ),
      )}
    </div>
  );
};

export default Summary;
